module.exports = __webpack_public_path__ + "img/erwinrichardkoch.998af9d0.jpg";